import { WebStorageStateStore, UserManager } from "oidc-client-ts";

const CONFIG = {
  authority: "${auth.url}",
  client_id: "${auth.client_id}",
  redirect_uri: "${auth.redirect_uri}",
  silent_redirect_uri: "${auth.redirect_uri}",
  response_type: "code",
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: false,
  extraQueryParams: {
    kc_idp_hint: "ciam",
  },
};

const userManager = new UserManager(CONFIG);

export default userManager;
